import React from 'react';
import { Box, Typography, Grid, TextField } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface ContactFieldsSectionProps {
  control: Control<any>;
}

const ContactFieldsSection: React.FC<ContactFieldsSectionProps> = ({ control }) => {
  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Contact Info
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Email" fullWidth size="small" type="email" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Phone" fullWidth size="small" />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactFieldsSection;
